import React, { useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  id: string[];
  requestId: string;
  onSuccess?: (ids: string[]) => void;
};

const CompleteRequestModal = ({ isOpen, onRequestClose, id, requestId, onSuccess }: Props) => {
  const [loading, setLoading] = useState(false);
  const onConfirm = async () => {
    const data = {
      procurement_item_ids: id
    };
    try {
      setLoading(true);
      const res = await apiService.put(`procurement/${requestId}/complete`, {
        data,
        version: 'v2'
      });
      if (res) {
        toast(<ToastMessage type='success' message=' Items received' />);
        onSuccess?.(id);
        onRequestClose();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentClassName='w-[80vw] max-w-[500px]'>
      <div className='p-6 flex flex-col justify-center items-center'>
        <ErrorIcon className='mb-3' />
        <h4 className='text-[24px] font-semibold text-[#2E3031] mb-4 text-center'>
          Are you sure you want to complete this request?
        </h4>
        <p className='text-sm text-[#6F7376] mb-6'>
          You won’t be able to receive or return items after this request is complete.
        </p>
        <div className='flex gap-4 justify-center'>
          <Button
            variant='block'
            color='gray'
            onClick={onRequestClose}
            className='text-sm mr-4 hover:text-[#FF0000] transition duration-300 h-[41px] w-[139px] !bg-[#F2F2F2] !text-gray-6 !border-[#F2F2F2]'>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            loading={loading}
            onClick={onConfirm}
            className='text-sm text-[#FF0000] hover:text-[#FF0000] transition duration-300 h-[41px] w-[139px]'>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default CompleteRequestModal;
